module.exports = __webpack_public_path__ + "72639ca17e6014e142e7cee3cdf1e1ad.png";